// eslint-disable-next-line import/prefer-default-export
export { useFeatureSwitch } from './feature-switch.hook';
